module.exports = __webpack_public_path__ + "static/media/icon_chat_dark.fb3302ac.svg";